import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {
  // Auth,
  // Welcome,
  // Login,
  // Register,
  Boodschapp,
  ListsOverview,
  List,
  AddList,
  ShowList,
  Categories,
  Category,
  AddCategory,
  ShowCategory,
  AddProduct
} from '@/components/pages'
import {
  Wrapper
} from '@/components/organisms'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   component: Auth,
    //   children: [
    //     {
    //       path: '',
    //       component: Welcome,
    //       name: 'welcome',
    //       meta: {title: 'Welkom'}
    //     },
    //     {
    //       path: 'login',
    //       component: Login,
    //       name: 'login',
    //       meta: {title: 'Inloggen'}
    //     },
    //     {
    //       path: 'register',
    //       component: Register,
    //       name: 'register',
    //       meta: {title: 'Registreren'}
    //     }
    //   ]
    // },
    {
      path: '/',
      name: 'boodschapp',
      component: Boodschapp,
      redirect: '/lists',
      children: [
        {
          path: '/lists',
          component: Wrapper,
          children: [
            {
              path: '',
              component: ListsOverview,
              name: 'lists'
            },
            {
              path: 'new',
              component: AddList,
              name: 'addList'
            },
            {
              path: ':id',
              component: List,
              beforeEnter: (to, from, next) => {
                const nextView = store.state.listsStore.lists.find(list => list.id === to.params.id)
                if (nextView !== undefined) next()
                else router.push({name: 'lists'})
              },
              children: [
                {
                  path: '',
                  component: ShowList,
                  name: 'list'
                }
              ]
            }
          ]
        },
        {
          path: '/categories',
          component: Wrapper,
          // beforeEnter: (to, from, next) => {
          //   const nextView = store.getters.getCategories.find(cat => cat.id === to.params.id)
          //   console.log(nextView, to.params.id)
          //   if (nextView !== undefined) next()
          //   else router.push({name: 'categories'})
          // },
          children: [
            {
              path: '',
              name: 'categories',
              component: Categories
            },
            {
              path: 'new',
              component: AddCategory,
              name: 'addCategory'
            },
            {
              path: ':id',
              component: Category,
              children: [
                {
                  path: '',
                  component: ShowCategory,
                  name: 'category'
                }
              ]
            }
          ]
        },
        {
          path: '/product',
          component: Wrapper,
          children: [
            {
              path: 'new',
              component: AddProduct,
              name: 'addProduct'
            }
          ]
        }
      ]
    },
    {
      path: '*',
      // name: 'Welcome',
      // component: Welcome,
      redirect: '/lists'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js